<template>
  <div>
    <p class="is-size-7 has-text-centered">Informe o código recebido por e-mail: </p>
    <form
      ref="form"
      class="two-factor-auth__form"
      @submit.prevent="valid() ? login() : null"
      novalidate>
      <sc-field class="has-text-centered">
        <sc-input
          focus
          type="number"
          name="twoFactorCode"
          ref="twoFactorCode"
          max="999999"
          maxlength="8"
          placeholder="Código recebido por e-mail"
          v-model="form.twoFactorCode"
          required
          :customClass="'has-text-centered'" />
      </sc-field>
      <sc-field>
        <sc-button
          type="submit"
          theme="primary"
          class="is-fullwidth"
          text="Entrar"
          :loading="loading" />
      </sc-field>
    </form>
    <div class="is-size-7 has-text-centered">
      <p>Não recebeu o código?</p>
      <p>
        <a
          href
          @click.prevent="resendTwoFactorCode">Clique aqui para reenviar.</a>
      </p>
    </div>
  </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  import {
    Storage, // eslint-disable-line
    Auth, // eslint-disable-line
    Moment, // eslint-disable-line
  } from '@intelipost-js/secure-providers';

  import {
    ScField,
    ScInput,
    ScButton,
  } from '@intelipost-js/secure-components';

  const { mapActions } = createNamespacedHelpers('auth');
  export default {
    name: 'form-two-factor-auth',
    props: {
      email: {
        type: String,
      },
      isTwoFactorAuth: {
        type: Boolean,
      },
      saveEmail: {
        type: Boolean,
      },
    },
    data() {
      return {
        loading: false,
        storageEmailKey: 'lastEmail',
        form: {
          twoFactorCode: null,
        },
      };
    },
    methods: {
      ...mapActions([
        'getTwoFactorCode',
        'getLoginTwoFactorAuth',
      ]),
      valid() {
        const { twoFactorCode } = this.$refs;
        return twoFactorCode.checkHtml5Validity();
      },
      login() {
        const params = this.form;
        const { twoFactorCode } = params;
        const { email } = this;
        const args = {
          email,
          twoFactorCode,
        };
        this.loading = true;
        return this.getLoginTwoFactorAuth(args).then((loginResponse) => {
          const { client = {}, user = {} } = loginResponse;
          const {
            sandbox_id = null,
            id: client_id = null,
          } = client;
          const { security } = user;
          Auth.updateUser(Object.assign(user, {
            client_id,
            sandbox_id,
            security: {
              ...security,
              session_start: Moment(),
            },
          }));
          return Auth.setMenu();
        })
        .then(() => this.$store.dispatch('notifications/getNotifications'))
        .then(() => this.logUser())
        .catch(() => { this.loading = false; });
      },
      logUser() {
        this.loading = false;
        if (this.saveEmail) {
          Storage.set(this.storageEmailKey, this.email);
        } else {
          Storage.remove(this.storageEmailKey);
        }
        Storage.set('RemoteAccess', { status: false });
        const path = this.$route.query.redirect || '/dashboard';
        this.$router.push({ path });
      },
      resendTwoFactorCode() {
        const { email } = this;
        this.getTwoFactorCode({ email });
      },
    },
    components: {
      ScField,
      ScInput,
      ScButton,
    },
  };
</script>

<style scoped>
.two-factor-auth__form{
  padding: 0.75rem 0 1.5rem 0;
}
</style>



// WEBPACK FOOTER //
// src/features/public/login/default/forms/FormTwoFactorAuth.vue?98919af4